// Static pages a campaign may want to override. The key is what the app
// asks for; the value is the slug used when a campaign has no override.
export const STATIC_PAGE_KEY = Object.freeze({
  ORDER_DETAIL: 'orderDetail',
  VIP_ORDER_DETAIL: 'vipOrderDetail',
  INSTALLMENT_PLAN_MODAL: 'installmentPlanModal',
  PROMOTION_AND_PRIVILEGES_MODAL: 'promotionAndPrivilegesModal',
  VIP_WELCOME_MODAL: 'vipWelcomeModal',
})

export const DEFAULT_STATIC_PAGE_SLUG = Object.freeze({
  [STATIC_PAGE_KEY.ORDER_DETAIL]: 'marketing-banner',
  [STATIC_PAGE_KEY.VIP_ORDER_DETAIL]: 'vip-marketing-banner',
  [STATIC_PAGE_KEY.INSTALLMENT_PLAN_MODAL]: 'installment-plan-modal',
  [STATIC_PAGE_KEY.PROMOTION_AND_PRIVILEGES_MODAL]:
    'promotion-and-privileges-modal',
  [STATIC_PAGE_KEY.VIP_WELCOME_MODAL]: 'waitlist-modal-banner',
})

// VUE_APP_CAMPAIGN_STATIC_PAGE_SLUGS holds a JSON object keyed by campaign
// slug, e.g. { "campaign-a": { "orderDetail": "marketing-banner-a" } }.
// A malformed value must not take the app down: fall back to {} so every
// campaign keeps the default slugs.
const parseOverrides = () => {
  try {
    const parsed = JSON.parse(
      process.env.VUE_APP_CAMPAIGN_STATIC_PAGE_SLUGS || '{}',
    )

    return parsed &&
      typeof parsed === 'object' &&
      !Array.isArray(parsed)
      ? parsed
      : {}
  } catch {
    return {}
  }
}

const CAMPAIGN_STATIC_PAGE_SLUGS = parseOverrides()

export const getCampaignStaticPageSlug = (campaignSlug, key) => {
  const override = CAMPAIGN_STATIC_PAGE_SLUGS[campaignSlug]?.[key]

  return (
    (typeof override === 'string' && override.trim()) ||
    DEFAULT_STATIC_PAGE_SLUG[key] ||
    ''
  )
}

export default getCampaignStaticPageSlug
